 <template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">Tambah Sparepart</h4>
							
							<div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Nomor Polisi Mobil<span style="color: red;">*</span></label>
											<input type="text" class="input--style-4" v-model="data.registration"/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Pilih Part<span style="color: red;">*</span></label>
											<multi-select
											v-if="sparepartMaster"
											class="mt-1"
											:options="sparepartMaster[sparepart_type].map(x => x.id).sort()"
											:custom-label="opt => sparepartMaster[sparepart_type].find(x => x.id == opt).name"
											placeholder="Pilih Sparepart Mobil"
											v-model="selectSparepart"
											/>
										</div>
									</div>
								</div>
							
								<div class="row row-space">
									<div class="col-12 col-md-6">
										<div class="input-group">
											<label class="label">Jumlah Sparepart<span style="color: red;">*</span></label>
											<input class="input--style-4" type="number" :step="'1'"  v-model="data.amount">
										</div>
									</div>
									<div class="col-12 col-md-6">
										<div class="input-group">
											<label class="label">Deskripsi Part<span style="color: red;">*</span></label>
											<input type="text" class="input--style-4" v-model="data.description"/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-12 col-md-6">
										<div class="input-group">
											<label class="label">Brand Mobil</label>
											<multi-select
												id="car_brand"
												class="mt-1"
												v-if="options.brand"
												:options="options.brand.map(x => x.id)"
												:custom-label="opt => options.brand.find(x => x.id == opt).name"
												v-model="selectedBrand"
												placeholder="Isi Merek Mobil"
											/>
										</div>
									</div>
									<div class="col-12 col-md-6">
										<div class="input-group">
											<label class="label">Tipe Mobil</label>
											<multi-select
												id="car_brand"
												class="mt-1"
												v-if="options.model"
												:disabled="!selectedBrand"
												:options="options.model.map(x => x.id)"
												:custom-label="opt => options.model.find(x => x.id == opt).name"
												v-model="data.car_id"
												placeholder="Isi Merek Mobil"
											/>
										</div>
									</div>
								</div>
								<!-- :custom-label="opt => options.brand.find(x => x.id == opt).name" -->
							</div>

							<div class="row" style="margin-bottom:100px">
								<div class="col mt-5" style="text-align: center">
									<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
									<button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button>
								</div>
							</div>
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
	components : {
		MultiSelect
	},
	data () {
		return {
			sparepart_type: 'P',
			sparepartMaster: null,
			data : {
				sparepart_id : null,
				amount : null,
				description : null,
				car_id : null,
				registration : null
			},
			options : {
				brand : [],
				model : [],
				modelFull : []
			},
			selectedBrand : null,
			processSparepart : false,
			selectSparepart : null
		}
  	},
  	watch : {
		sparepart_type : function() {
			this.data.sparepart_id = null
			this.selectSparepart = null;
			this.data.amount = this.sparepart_type == 'J' ? 1 : 0
			this.data.attachment_id = null;
			this.data.sparepart_size = null;
		},
		'selectSparepart' : function () {
			this.searchSparepartID(this.selectSparepart , this.sparepart_type)
		},
		selectPartNumber : function () {
			this.data.sparepart_id = this.selectPartNumber
		},
		selectedBrand : function () {
			this.options.model = this.options.modelFull.filter(x => x.brand_id == this.selectedBrand)
		},
	},
	mounted () {
	// console.log(this.options)  
		this.loadSparepartData()
		this.data.amount = 1;
		this.loadCarType()
	},
	methods : {
		searchSparepartID (sparepart  , type ) {
			let url = `/api/v1/masterData/sparepart`

			this.$http.get(url + `?variant_id=${this.selectSparepart}`)
			.then((resp) => {
				this.data.sparepart_id = resp.data.data[0]
				this.price = this.insurancePriceList.find(x => x.sparepart_id == this.data.sparepart_id.id)
				this.price = this.price ? this.price : 0
				if(this.sparepart_type == 'J')
					this.data.price_per_item = this.price ? parseFloat(this.price.price) : null
				else {
					delete this.data.price_per_item
					this.data.attachment_id = this.data.sparepart_id.sparepart_variants.sparepart_attachment_id
				}

			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadCarType () {
			var urlBrand = `/api/v1/masterData/car/brand?pagination=false`
			var urlType =  `/api/v1/masterData/car/model?pagination=false`

			this.$http.get(urlBrand).then((resp) => {
				this.options.brand = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})

			this.$http.get(urlType).then((resp) => {
				this.options.modelFull = resp.data.data
				this.options.model = JSON.parse(JSON.stringify(this.options.modelFull))
			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadSparepartData () {
			this.sparepartMaster = null

			let data = {
				J : [],
				P : [],
				B : []
			}
			this.$http.get(`/api/v1/masterData/sparepart/variants?pagination=false`)
			.then((resp) => {
				let sparepartMaster = resp.data.data
				for(var i = 0 ; i < sparepartMaster.length ; i++) {
				if(sparepartMaster[i].sparepart_type.id == 1) {
					data.J.push(sparepartMaster[i])
				}
				else if(sparepartMaster[i].sparepart_type.id == 2) {
					data.P.push(sparepartMaster[i])
				}

				}

				this.sparepartMaster = data
				// console.log(this.sparepartMaster)
			})
			.catch((err) => {console.log(err)})
		},
		validateForm(){
			var valid = true;
			var error = [];
			this.data.amount  = parseFloat(this.data.amount)
			console.log(this.data.amount)

			if(this.data.sparepart_id == '' || this.data.sparepart_id == null){//Sparepart [Required]
				valid = false;
				error.push('Sparepart wajib dipilih!');
			}

			if(this.data.amount <= 0 ){//Name [Required]
				valid = false;
				error.push('Jumlah Sparepart tidak boleh 0!');
			}


			if(this.sparepart_type == 'P' && (this.data.description == '' || !this.data.description)) {
				valid = false;
				error.push('Part Description Tidak Boleh Kosong.');
			}

			if(this.sparepart_type == 'P' && (this.data.registration == '' || !this.data.registration)) {
				valid = false;
				error.push('Nomor Polisi Tidak Boleh Kosong.');
			}

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		},
		async submitForm() {
			if(this.processSparepart) {
				this.$store.dispatch('triggerAlert' , [false , 'Sparepart is processing.. please wait a moment'])
				return
			}
			this.processSparepart = true
			if(this.validateForm()){
				this.data.sparepart_id = this.data.sparepart_id.id
				this.$http.post('/api/v1/estimations/pending-estimation' , this.data)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
					this.$emit('updateTable');
					this.$emit('closeModal');
				})
				.catch((err) => {

					let errObj = err.response.data.data
					let errMessage = ''
					if(errObj.name == 'DBError') {
						errMessage = errObj.nativeError.sqlMessage
					}
					else {
						errMessage = errObj.message
					}
					// console.log(errObj)

					this.$store.dispatch('triggerAlert' , [false, errMessage])
					this.processSparepart = false
				})
			}
			else {
				this.processSparepart = false
			}
		}
	},
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
